<template>
  <div class="height100" ref="flowCon">
    <div class="delbtn ">
        <el-button @click="showBatchUser" size="small" type="primary" plain >批量更新当前节点审批人</el-button>
        <el-button @click="onDeleteBtnClick" size="small" type="danger" plain >{{$t('del')}}</el-button>
    </div>
    <el-tabs  @tab-click="handleClick" class="tabs height100 flowstatertsCon">
      <el-tab-pane :label="$t('flowstaterts')" ref="flowCon" class="height100">
        <el-container class="height100">
          <el-container v-show="showmode=='LIST'" class="el-mainContent marginTop10"  direction="vertical" >
            <el-form :model="searchdata.data" ref="searchdata" label-position="top" label-width="180px" size="mini"  @submit.native.prevent>
              <el-row>
                <el-col :span="4">
                  <el-form-item  prop="application" class="marginBot10">
                    <el-select v-model="searchdata.data.application" class="el-select-w">
                      <el-option 
                        key=" "
                        :label="$t('placeholder_select')"
                        value="">
                      </el-option>
                      <el-option v-for="item in customApps.datas" 
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select> 
                  </el-form-item>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-form-item  prop="_flowName"  class="marginBot10">
                    <el-input :placeholder="$t('flowName')" v-model="searchdata.data._flowName" @keyup.enter.native="searchTableData"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-form-item  prop="_stateLabel"  class="marginBot10">
                    <el-input :placeholder="$t('stateLabel')" v-model="searchdata.data._stateLabel" @keyup.enter.native="searchTableData"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-form-item  prop="_initiator"  class="marginBot10">
                    <el-input :placeholder="$t('initiator')" v-model="searchdata.data._initiator" @keyup.enter.native="searchTableData"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4">
                  <el-form-item prop="_firstProcessTime"  class="marginBot10">
                    <el-date-picker :placeholder="$t('firstProcessTime')" v-model="searchdata.data._firstProcessTime" type="date" style="width: 100%"
                    value-format='yyyy-MM-dd'
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-form-item  prop="_lastAuditor"  class="marginBot10">
                    <el-input :placeholder="$t('lastAuditor')" v-model="searchdata.data._lastAuditor" @keyup.enter.native="searchTableData"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-form-item  prop="_lastProcessTime" class="marginBot10">
                    <el-date-picker :placeholder="$t('lastProcessTime')" v-model="searchdata.data._lastProcessTime" type="date" style="width: 100%" value-format='yyyy-MM-dd'></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-form-item prop="_summary" class="marginBot10">
                    <el-input :placeholder="$t('summary')" v-model="searchdata.data._summary" @keyup.enter.native="searchTableData"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-row>
                      <el-col :span="8"><el-button type="primary" plain @click="searchTableData" size="mini">{{$t('query')}}</el-button></el-col>
                      <el-col :span="8"><el-button @click="resetForm('searchdata')" size="mini">{{$t('reset')}}</el-button></el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-form>
            <!-- 流程监控列表 -->
            <el-table :data="tableData.datas"
            stripe
            @row-click="onRowClick"
            class="Trpointer" 
            ref="multipleTable"
            :row-key="handleReserve" 
            @selection-change="handleSelectionChange"
            header-cell-class-name="tableHeaderbg"
            size="small"
            :height="tableListConHeight">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="flowName" :label="$t('flowName')"></el-table-column>
              <el-table-column prop="stateLabel" :label="$t('stateLabel')"></el-table-column>  
              <el-table-column prop="auditorNames" label="当前审批人"></el-table-column>  
              <el-table-column prop="initiator" :label="$t('initiator')"></el-table-column>
              <el-table-column prop="firstProcessTime" :label="$t('firstProcessTime')"></el-table-column>
              <el-table-column prop="lastAuditor" :label="$t('lastAuditor')"></el-table-column>
              <el-table-column prop="lastProcessTime" :label="$t('lastProcessTime')"></el-table-column>
              <el-table-column  :label="$t('summary')" >
                <template slot-scope="scope">
                  <a v-html="scope.row.summary" v-if="scope.row.showTags"></a>
                  <a v-if="!scope.row.showTags">{{scope.row.summary}}</a>
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
            ref="pagination"
              @size-change="handleSizeChange"
              @current-change="searchTableData"
              :current-page.sync="searchdata.currpage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="searchdata.pagelines"
              layout="prev, pager, next, total, sizes"
              background
              :total="tableData.rowCount?tableData.rowCount:0"
            ></el-pagination>
          </el-container>
        </el-container>
      </el-tab-pane>

      <el-tab-pane :label="$t('flowboard')" class="height100">
        <flowstaterts_panel v-if="tabNow" />
      </el-tab-pane>
    </el-tabs>
    <flowstaterts_detail @ok="ok" v-if="detailVisible" :visible.sync="detailVisible" :applicationId="detail.applicationid" :id="detail.id"/>
    <roleBatchUser :visible.sync="roleBatchUserVisible" v-if="roleBatchUserVisible" :updateBatchUser="true" :docIdSelection="docIdSelection"/>
    
  </div>
</template>

<script>
import flowstaterts_detail from "@/components/flowstaterts_detail.vue";

import flowstaterts_panel from "@/components/flowstaterts_panel.vue";

import roleBatchUser from "@/components/roleBatchUser.vue";

export default {
  components:{
    flowstaterts_panel,
    flowstaterts_detail,
    roleBatchUser
  },
  created() {
    this.searchTableData();
    this.$api.getCustomAppConfig(
      { domainid: this.$route.query.domainid, data:{name: ""} },
      {
        onSucess: resp => {
          this.customApps = resp.data.data;
        }
      }
    );
  },
  mounted(){
    this.tableListConHeight = this.$refs.flowCon.offsetHeight-40-76-44;
    console.log(this.tableListConHeight)
  },
  data() {
    return {
      searchdata: {
        domainid: this.$route.query.domainid,
        currpage: 1,
        pagelines: 10,
        
        data:{
          "application": "",
          "_flowName": "",
          "_stateLabel": "",
          "_initiator": "",
          "_firstProcessTime": "",
          "_lastProcessTime": "",
          "_lastAuditor": "",
          "_summary": "",
        }
      },
      tableData: {
        datas: [],
        rowCount: 0
      },
      showmode: "LIST",
      multipleTable:[],
      multipleSelection:[],
      docIdSelection: [],
      checked: true,
      customApps: [],
      application:"",
      tabNow:false,
      detailVisible:false,
      detail:{},
      tableListConHeight:0,
      roleBatchUserVisible:false,
    };
  },
  methods: {
    replaceSpeChar(char){
      let text = char;
      text = text.replace(/&amp;/g, '&');
      text = text.replace(/@amp;/g, '&');
      text = text.replace(/&quot;/g, '"');
      text = text.replace(/@quot;/g, '"');
      text = text.replace(/&lt;/g, '<');
      text = text.replace(/@lt;/g, '<');
      text = text.replace(/&gt;/g, '>');
      text = text.replace(/@gt;/g, '>');
      text = text.replace(/&#146;/g, "'");
      text = text.replace(/@#146;/g, "'");
      text = text.replace(/&nbsp;/g, ' ');
      text = text.replace(/@nbsp;/g, ' ');
      text = text.replace(/&#10;/g, '\r');
      text = text.replace(/&#13;/g, '\n');
      text = text.replace(/&#9;/g, ' ');
      text = text.replace(/%23/g, '#');
      text = text.replace('\n\r', '\n');
      text = text.replace('\r\n', '\n');
      return text;
    },
    ok(){
      this.searchTableData();
    },
    handleClick(tab){
      if(tab.label==this.$t('flowboard')){
        this.tabNow=true;
      }else{
        this.tabNow=false;

      }
    },
    handleReserve(row){
      return row.id
    },
    showBatchUser(){
      if(this.multipleSelection.length > 0){
        this.roleBatchUserVisible=true;
      }else{
        this.$message.error('请选择流程记录')
      }
    },
    onDeleteBtnClick(){
      if(this.multipleSelection.length>0){
        this.$api.deleteFlowstaterts({
          applicationid: this.tableData.datas[0].applicationid,////
          data: this.multipleSelection
        },{
          onSucess:resp =>{
            if(resp.data.errcode==0){
              this.$message({
                  showClose: true,
                  message: this.$t('msg_del_success'),
                  type: "success"
              });
              this.searchTableData()
            }else{
              this.$message({
                  showClose: true,
                  message: resp.data.errmsg,
                  type: "error"
              });
            }
          },
          onError:function(){

          }
        });
      }else{
        this.$message({
          showClose: true,
          message: this.$t('msg_select_flowdata'),
          type: "error"
        });
        return false;
      }
    },
    handleSelectionChange(val) {
      var arr = [];
      let docArr = []
      val.forEach((val) => {
        if(this.tableData.datas.length>0){
          this.tableData.datas.forEach((v) => {
            if(val.id == v.id){
              arr.push(val.id)
              docArr.push({
                applicationId: val.applicationid,
                docId: val.docId
              })
            }
          })
        }
        
      })   
      this.multipleSelection = arr;
      this.docIdSelection  = docArr
      console.log(arr, docArr)
    },
    resolvingDate(date){
      let d = new Date(date);

      let month = (d.getMonth() + 1) < 10 ? '0'+(d.getMonth() + 1) : (d.getMonth() + 1);
      let day = d.getDate()<10 ? '0'+d.getDate() : d.getDate();
      let hours = d.getHours()<10 ? '0'+d.getHours() : d.getHours();
      let min = d.getMinutes()<10 ? '0'+d.getMinutes() : d.getMinutes();
      let sec = d.getSeconds()<10 ? '0'+d.getSeconds() : d.getSeconds();

      let times=d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;

      return times
    },
    searchTableData(){
      if(!this.searchdata.data._firstProcessTime){
        this.searchdata.data._firstProcessTime=''
      }
      if(!this.searchdata.data._lastProcessTime){
        this.searchdata.data._lastProcessTime=''
      }
      this.$api.getFlowstaterts(this.searchdata, {
        onSucess: resp => {
          this.tableData = resp.data.data ? resp.data.data : {datas: [], rowCount: 0};
          // this.$set(this, 'tableData', resp.data.data)
          if(this.tableData.datas){
            this.tableData.datas.forEach(elm=>{
              elm.firstProcessTime=this.resolvingDate(elm.firstProcessTime)
              elm.lastProcessTime=this.resolvingDate(elm.lastProcessTime);
              let sum ;
              try{
                sum = JSON.parse(this.replaceSpeChar(elm.summary));
                sum = sum.summaryText.replace(/<[^>]*?>(.*?)/gi,'$1');
                elm.showTags=sum.showTags;
              }catch{
                sum = this.replaceSpeChar(elm.summary)
              }
              elm.summary=sum;
            })
          }
        }
      });
    },
    
    resetForm(formName){
      this.$refs[formName].resetFields();
      this.searchTableData();
    },
    onRowClick(row) {
      this.detailVisible=true;
      this.detail=row;
    },
    handleSizeChange(size){
      this.searchdata.pagelines=size;
      this.searchTableData();
    },
  },
}
</script>